export function SectionLabel({ children, className = "" }) {
  return (
    <p className={`text-xs tracking-[0.3em] uppercase text-violet-400 font-bold mb-5 ${className}`}>
      {children}
    </p>
  );
}
